module.exports = __webpack_public_path__ + "img/ic_404.677fdf58.png";